import classnames from 'classnames';
import { PureComponent } from 'react';

import { SafeInnerHtmlSetter } from 'components/shared/util/SafeInnerHtmlSetter';

import styles from './messageWidget.module.scss';

type PropsT = {
  /** Extra classnames */
  className?: string;
  /** Message markup */
  markup: string;
};

export class MessageWidget extends PureComponent<PropsT> {
  render() {
    const { className, markup, ...otherProps } = this.props;

    const rootClass = classnames(
      {
        [styles.root]: true,
      },
      className,
    );

    return (
      <SafeInnerHtmlSetter
        element="div"
        content={markup}
        profile="widgetchat"
        className={rootClass}
        {...otherProps}
      />
    );
  }
}
